import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import numDesc from 'helpers/numDesc';
import { I18nHoc, Trans } from 'helpers/i18n';
import Row, { Col } from 'components/row';

import translates from '../how-we-calculate-score-i18n';

const classes = new Bem('blockHowExpertWorks');

@I18nHoc(translates())
export default class HowExpertWorksBlock extends Component {
  static propTypes = {
    className: PropTypes.string,
    countCondition: PropTypes.number
  };

  render() {
    const { i18n } = this;
    const { className, countCondition } = this.props;
    const countConditionTxt = numDesc(
      countCondition,
      i18n('paragraph'),
      i18n('paragraphDeclination'),
      i18n('paragraphMultiple')
    );

    return (
      <div {...classes({ extra: className })}>
        <Row {...classes('row', 'block')} mtColumn mpColumn>
          <Col {...classes('col', 'img')} allPr={0}>
            <div {...classes('imgContainer')}>
              <img {...classes('img')} src={i18n('imgPDF2')} alt={i18n('howExpertWorksAlt')} loading="lazy" decoding="async" />
            </div>
          </Col>
          <Col {...classes('col', 'info')} allPr={0}>
            <div {...classes('text', 'h2')}><h2 children={i18n('howExpertWorksH2')} /></div>
            <Trans lang="ru">
              <ul {...classes('list')}>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="Эксперт ангажирован." />
                    <p {...classes('text')} children="Он ангажирован вами, ведь именно вы оплачиваете его работу." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="Эксперт всегда ставит себя на место инвестора при оценке ЖК, старается найти и показать ваши риски." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="Эксперт не даёт оценочных суждений ─ только факты и их анализ. Эксперт не делает прогнозов: проект строительства ЖК ─ это всегда проект." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('itemTopic')}>
                    <div {...classes('text', 'h3')}>
                      <h3 children="Процесс оценки ручной." />
                    </div>
                  </div>
                  <div {...classes('description', 'separatorLeft')}>
                    <p {...classes('text')} children={`Эксперт проверяет все ${countConditionTxt} отчёта по единой для всех ЖК методологии. Каждый пункт отчёта сопровождается ответом на вопрос, подтверждающими скринами документов, ссылками на реестры или документы, собственными комментариями.`} />
                  </div>
                </li>
              </ul>
            </Trans>
            <Trans lang="ua">
              <ul {...classes('list')}>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="Експерт заангажований." />
                    <p {...classes('text')} children="Він заангажований вами, адже саме ви оплачуєте його роботу." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="Експерт завжди ставить себе на місце інвестора при оцінці ЖК, намагається знайти і вказати на ваші ризики." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="Експерт не дає оціночних суджень ─ лише факти та їх аналіз. Експерт не робить прогнозів: проєкт будівництва ЖК ─ це завжди проєкт." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('itemTopic')}>
                    <div {...classes('text', 'h3')}>
                      <h3 children="Процес оцінки ─ ручний." />
                    </div>
                  </div>
                  <div {...classes('description', 'separatorLeft')}>
                    <p {...classes('text')} children={`Експерт перевіряє всі ${countConditionTxt} звіту за єдиною для всіх ЖК методологією. Кожен пункт звіту супроводжується відповіддю на запитання, які підтверджують скринами документів, посиланнями на реєстри або документи, власними коментарями.`} />
                  </div>
                </li>
              </ul>
            </Trans>
          </Col>
        </Row>
      </div>
    );
  }
}
